"use client";

import React, { useEffect, useRef } from "react";
import { ZoomIn } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_dojo.png",
  alt: "Dojo Lichtfluss mit hochwertigem Eichenparkett",
  gridClass: "md:col-start-1 md:row-start-1 md:row-span-2 min-h-[400px] md:min-h-0"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_hand.png",
  alt: "Detailaufnahme der Handhaltung im Tai Chi",
  gridClass: "md:col-start-2 md:row-start-1 h-[300px] md:h-[200px]"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_room.png",
  alt: "Heller Trainingsraum der Tai Chi Schule",
  gridClass: "md:col-start-2 md:row-start-2 h-[300px] md:h-[200px]"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_qigong.png",
  alt: "Qi Gong Training im Freien",
  gridClass: "md:col-start-2 md:row-start-3 h-[300px] md:h-[200px]"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_meditation.png",
  alt: "Stille und Fokus im Meditationsbereich",
  gridClass: "md:col-start-3 md:row-start-1 md:row-span-2 min-h-[400px] md:min-h-0"
}, {
  id: 6,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_forest.png",
  alt: "Die beruhigende Natur des Soonwalds",
  gridClass: "md:col-start-1 md:row-start-3 h-[300px] md:h-[200px]"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/soonwald_gallery_sword.png",
  alt: "Traditionelles Schwerttraining",
  gridClass: "md:col-start-3 md:row-start-3 h-[300px] md:h-[200px]"
}];
const ParallaxContainer = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          if (ref.current) {
            const rect = ref.current.parentElement?.getBoundingClientRect();
            if (rect && rect.top < window.innerHeight && rect.bottom > 0) {
              const scrollPercent = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
              const yOffset = (scrollPercent - 0.5) * 30;
              ref.current.style.transform = `translateY(${yOffset}px) scale(1.15)`;
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <div data-section-id="143846" ref={ref} className={`absolute inset-0 w-full h-full will-change-transform ${className || ""}`} style={{
    transform: "scale(1.15)"
  }}>
      {children}
    </div>;
};
export default function ImpressionsFromSoonwald() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}